var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarrerCardImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-99"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-99",
    cx: 252.3,
    cy: 353.91,
    rx: 233.16,
    ry: 133.64,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-99"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-99",
    cx: 413.54,
    cy: 325.57,
    rx: 50.75,
    ry: 29.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-99",
    cx: 94.69,
    cy: 394.95,
    rx: 47.89,
    ry: 27.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-99",
    cx: 250.86,
    cy: 356.32,
    rx: 40.92,
    ry: 23.62,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.43,359l5-2.7s2.68-13,1.18-24.21c-2.11-15.81-12.7-21.49-16.63-20s-5,6.11,1.86,15.38C179.85,332.92,184.91,344.39,184.43,359Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.43,359l5-2.7s2.68-13,1.18-24.21c-2.11-15.81-12.7-21.49-16.63-20s-5,6.11,1.86,15.38C179.85,332.92,184.91,344.39,184.43,359Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M186.36,352.79h-.05a.35.35,0,0,1-.29-.4c2.39-14.69-3.15-31-9.65-37.65a.35.35,0,1,1,.5-.49c6.63,6.79,12.27,23.35,9.85,38.25A.36.36,0,0,1,186.36,352.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.86,366.41c-.79.43-2.37-.59-3-1a7.48,7.48,0,0,1-2.4-2.89,7,7,0,0,1-.52-4.2,15.63,15.63,0,0,1,.58-2.21c.23-.72.45-1.43.67-2.15a5.23,5.23,0,0,0,.37-2.17c-.15-1.48-1.44-2.54-2.61-3.46s-2.63-2.36-2.58-4.14a6.3,6.3,0,0,1,1.65-3.68c.88-1.06,1.91-2,2.71-3.1a4.44,4.44,0,0,0,1-2.74,4.5,4.5,0,0,0-.56-1.74,25.91,25.91,0,0,1-1.81-3.51,3.5,3.5,0,0,1,.69-3.67,4.06,4.06,0,0,1,3.08-.68,7,7,0,0,1,2.82,1.07c2.78,1.63,4.31,5,7.28,6.3a31.3,31.3,0,0,0,3.6,1,4.47,4.47,0,0,1,2.94,2.12c1.05,2.22-1.06,4.88-.34,7.23.64,2.08,2.62,2.91,3.7,4.8a4.3,4.3,0,0,1,.46,2.71,13,13,0,0,1-1.24,4.54,33.16,33.16,0,0,1-2.61,4S171,366.34,170.86,366.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,362.34h0a.35.35,0,0,1-.33-.38c.91-13.93-5.29-29.5-10-34.09a.35.35,0,0,1,0-.49.36.36,0,0,1,.5,0c4.77,4.69,11.1,20.51,10.17,34.64A.35.35,0,0,1,179,362.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27,345.8h-.11a46.69,46.69,0,0,0-10.08-1.88.35.35,0,0,1-.33-.37.33.33,0,0,1,.37-.33,47.94,47.94,0,0,1,10.27,1.91.36.36,0,0,1,.22.45A.33.33,0,0,1,177.27,345.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312,336.72l-5.38-3.11s-1.32-11.54-.44-20.47c1.23-12.55,9.34-27.66,19-24.11s-4.44,16.33-7.58,27S312,336.72,312,336.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,336.72l-5.38-3.11s-1.32-11.54-.44-20.47c1.23-12.55,9.34-27.66,19-24.11s-4.44,16.33-7.58,27S312,336.72,312,336.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.17,335.41h0a.34.34,0,0,0,.32-.34c-.95-27.89,12.94-41.92,13.08-42.06a.33.33,0,0,0,0-.46.32.32,0,0,0-.46,0c-.14.14-14.23,14.37-13.28,42.54A.34.34,0,0,0,309.17,335.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.88,338.94l-3.83-2.21a42.18,42.18,0,0,1,3.22-17.53c3.38-8.37,11.76-15.32,16-13.86s4.11,4.45,2.06,7.59S317.75,323.54,314.88,338.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.86,338.1h0a.32.32,0,0,0,.32-.33c-.07-17.63,16.48-29.55,16.65-29.67a.32.32,0,0,0,.08-.45.31.31,0,0,0-.45-.08c-.17.12-17,12.24-16.93,30.21A.32.32,0,0,0,312.86,338.1Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.89,173.39c16.72-1.51,32.59-4.24,37.75-10.88-4.55-3.58-5.69-4.28-10.45-4.24-4.23,0-22.48,5.27-28.08,4.87-3.88-1.94-15.78-11.15-20.15-14.3-.78-.55-6.73,6.38-3.18,9.47,5,4.34,13.28,10.62,18,13.29C366.85,172.79,368.49,173.61,370.89,173.39Z",
    style: {
      fill: "#ffc1a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.05,105.61h0a1.31,1.31,0,0,0-.83.08L380,109.84a1.08,1.08,0,0,1-1.53-.7c-.36-1.17-6.67-2.5-7.19-3.5l3.54-8.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.84,96.88v0a.86.86,0,0,0-.8,0l-6.8-15.73a1.41,1.41,0,0,0-.55-1.81L360,75.47a1.38,1.38,0,0,0-1.83.43l-7.66,11.5a2.52,2.52,0,0,1-2,1,18.61,18.61,0,0,0-2.67.12V80.11l-5.11-3h0a.86.86,0,0,0-.84.08l-10.35,6a2.77,2.77,0,0,0-1.23,1.93l-1,11.52a3.79,3.79,0,0,1-1.08,2.15,62.72,62.72,0,0,0-5.74,6.08,2,2,0,0,1-2,.58l-6.64-2.32a1.6,1.6,0,0,0-1.86.69L302.33,117a1.61,1.61,0,0,0,.33,2l5.33,4.59a2,2,0,0,1,.52,2.05,62.25,62.25,0,0,0-2.4,8,3.83,3.83,0,0,1-1.32,2l-9.46,6.66a2.79,2.79,0,0,0-1.05,2v11.95a.84.84,0,0,0,.37.77h0l12,6.92-4.37,8.81a1.38,1.38,0,0,0,.54,1.8L319.09,184a1.4,1.4,0,0,0,1.83-.43l7.4-7.57a.88.88,0,0,0,.4.7l15.17,8.76.41-11.88s-3.21-4.14-3.15-4.85l16.54-18a1.62,1.62,0,0,0,1.87-.69l7.6-13.18a1.62,1.62,0,0,0-.33-2l7.33-23.32a2.79,2.79,0,0,0,1-2Zm-40.09,50.26c-4.45,2.56-8.11,3.11-10.78,1.87-3.13-1.46,22.27-45,24.93-42.62,2.16,1.92,3.33,5.48,3.33,10.47C352.23,128,344.4,141.56,334.75,147.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.37,87l-2.06,4.16-6.61,7.63-7.79-4.51L350,87.93a1.74,1.74,0,0,0,.55-.53l7.65-11.5a1.39,1.39,0,0,1,1.82-.44l6.68,3.86,10.13,5.84A1.38,1.38,0,0,1,377.37,87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.49,134.91a3.34,3.34,0,0,1-.7.74l-9.46,6.66a2.54,2.54,0,0,0-.65.75l15.9,9.2,12.55-7.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.18,103.08a1.64,1.64,0,0,0-1.24.76L302.33,117a1.48,1.48,0,0,0-.17,1l16.65,9.64,10.42-14.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,85.94v3.79l-9.21,5.32L328.5,84.51a2.71,2.71,0,0,1,1.07-1.29l10.35-6a1.09,1.09,0,0,1,.51-.15.66.66,0,0,1,.32.07l5,2.87.13.08,6.88,4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.42,118.34v-12a.77.77,0,0,0-1.17-.76L380,109.78a1.1,1.1,0,0,1-1.54-.71,20.23,20.23,0,0,0-2.05-4.56,2.54,2.54,0,0,1-.14-2.23l6.14-12.38a1.4,1.4,0,0,0-.55-1.81l-6.66-3.84a1.38,1.38,0,0,0-1.83.43l-7.65,11.5a2.54,2.54,0,0,1-2,1,20.83,20.83,0,0,0-5,.5,1.08,1.08,0,0,1-1.38-1l-1-10a.77.77,0,0,0-1.25-.64l-10.35,6a2.8,2.8,0,0,0-1.23,1.93l-1,11.52a3.83,3.83,0,0,1-1.07,2.15,61.61,61.61,0,0,0-5.75,6.08,2,2,0,0,1-2,.58L327,111.93a1.6,1.6,0,0,0-1.86.69l-7.61,13.18a1.61,1.61,0,0,0,.33,2l5.33,4.59a2,2,0,0,1,.52,2.05,62.25,62.25,0,0,0-2.4,8,3.83,3.83,0,0,1-1.32,2l-9.45,6.66a2.77,2.77,0,0,0-1.06,2v11.95a.77.77,0,0,0,1.18.76l9.21-4.15a1.09,1.09,0,0,1,1.53.71,20.79,20.79,0,0,0,2.06,4.57,2.57,2.57,0,0,1,.14,2.23l-6.14,12.38a1.38,1.38,0,0,0,.54,1.8l6.66,3.85a1.41,1.41,0,0,0,1.84-.43l7.65-11.51a2.54,2.54,0,0,1,2-1,20.89,20.89,0,0,0,5-.51,1.09,1.09,0,0,1,1.38,1l1,10.06a.77.77,0,0,0,1.24.64l10.35-6a2.81,2.81,0,0,0,1.24-1.93l1-11.52a3.88,3.88,0,0,1,1.08-2.15,61.67,61.67,0,0,0,5.75-6.08,2,2,0,0,1,2-.58l6.64,2.32a1.62,1.62,0,0,0,1.87-.69l7.61-13.18a1.63,1.63,0,0,0-.34-2l-5.33-4.59a2,2,0,0,1-.51-2.05,63.67,63.67,0,0,0,2.39-8,3.83,3.83,0,0,1,1.33-2l9.45-6.65A2.79,2.79,0,0,0,390.42,118.34ZM350,155.92c-9.66,5.57-17.49,1.05-17.49-10.09s7.83-24.71,17.49-30.29,17.48-1.05,17.48,10.1S359.61,150.34,350,155.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.85,153.85h.68a17.2,17.2,0,0,0,17.2-17.2h0a16.57,16.57,0,0,0-16.58-16.57h-1.93a16.57,16.57,0,0,0-16.57,16.57h0A17.2,17.2,0,0,0,408.85,153.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.44,163.53h0a10,10,0,0,1-10-10V131.42h0a10,10,0,0,1,10,10Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.91,309.69c-.63,1.27-.34,2.87-.45,6.32a59.59,59.59,0,0,1-.4,6.82c-.12.81-.4,1.54-.59,2.33a2.81,2.81,0,0,1-.94,1.6,1.73,1.73,0,0,1-1.56.41,1.61,1.61,0,0,1-1-.86,12.25,12.25,0,0,1-.85-2.4c-.76,5.78-6.64,9.53-2.84,11,3.3,1.3,5.65.25,7.7-.63a6.82,6.82,0,0,0,2.65-2.2c1.52-2.54,1.32-4.87,1.38-7.08A41.63,41.63,0,0,1,447.3,316C447.83,313,443.85,309.27,442.91,309.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.9,312.57l-4.73-11.89,7.87-3c.94,1.86,3.38,11.33,3.87,12a5.63,5.63,0,0,1,1.22,3.36,55,55,0,0,1-1.47,11.71,5.27,5.27,0,0,1-3.18,3.77,3.8,3.8,0,0,1-2,.43,1,1,0,0,1-.62-.25c-.33-.35,0-1.14.06-1.54a15.72,15.72,0,0,0,.22-1.95c.06-1.28.05-2.84,0-4.12A41.5,41.5,0,0,0,435.9,312.57Z",
    style: {
      fill: "#ffc1a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.56,316.17a.53.53,0,0,1,.39.49c.1.66.2,1.87.4,3a14.83,14.83,0,0,1,.28,4.8c-.26,1.19-3.05,2.86-4.92,3.11a16.23,16.23,0,0,0-6.59,3.31,15.39,15.39,0,0,1-8.38,2.95c-3.08,0-5.5-.69-6.2-2.92-.29-.94.48-2.08,4.45-3.89,0,0,2-1,3.15-1.7,5.75-3.47,7.73-5.47,9.45-9.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.4,319.19a10.16,10.16,0,0,0,1.58-5.06l.13-4.91h8.48l0,6.95,0,1.06c-.48,3.37-3.66,3.76-6.31,5.63-1.32.92-6.49,4.9-10,5.54-2.82.51-3.88-.6-4.25-1.4A56.46,56.46,0,0,0,390.4,319.19Z",
    style: {
      fill: "#ffc1a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,265.07a32.89,32.89,0,0,1,8.62,12.18c2.61,6.65,5.83,29.4,5.83,29.4s-4,3.61-8.42,2.19c0,0-16.2-30.43-18.63-37.71-2.47-3.71-5.56-22-7.79-34.67l-.08.14-3.81,26.86a58.46,58.46,0,0,1,2.14,9.65c.63,6.59-4.92,38.5-4.92,38.5a12.32,12.32,0,0,1-9,.24s-1.87-40-2.46-47.92c-1-13.34-.45-52.54,2-60.43l34.93,1.95,0,0c2.89,8.37,3.12,13.72,2.75,22.9C428.72,237.82,428,265.07,428,265.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.5,236.6l-2-12.41s-8.39-1.74-12.2-5.32a21.7,21.7,0,0,0,9.93,6.6l2.23,9.55L404,261.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.56,159.06h0a14.89,14.89,0,0,1,5.87,1.26c2.67,1.49,2.9,4.17,2.94,7.35,0,3.49-.84,6.18-1.9,11.92l-2,11s2.95,6.69,5.87,14.81c-13.71,7.65-30.83,3.63-35-1.95-.17-1.19.89-10.44,1.54-16.49-2.42-6.06-3.05-9.9-2-13.9,1.89-7.43,9.23-14.67,12.47-14.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.75,208.74a33.05,33.05,0,0,0,8.6-3.29c-2.92-8.12-5.87-14.81-5.87-14.81l2-11c1-5.4,1.83-8.1,1.9-11.3l-5.26,1.47S396.52,181.93,396.43,182s-2.23,1.23-4.44,2.42c.28.81.59,1.65.95,2.56-.15,1.34-.31,2.85-.48,4.38a81.66,81.66,0,0,0,12.6-3.08c6.92-2.42,14.23-7.67,14.49-7.37s-.94,9-.94,9l-3.16-.6s4.93,6.15,6.33,8.82S424.54,206.35,417.75,208.74Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.32,126.77l-1.13,4.34a2.18,2.18,0,0,0,2.76-1.52A2.36,2.36,0,0,0,426.32,126.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.35,128.78l-3.76,2.47a2.19,2.19,0,0,0,3.08.72A2.37,2.37,0,0,0,429.35,128.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.77,127.53c-1.86,1.1-4.15,5.76-3.92,15.53.19,8.28,2.88,10.32,4.22,10.91s3.95.23,6.48-.19v5s-3.5,4.06-3.28,6.34,5.05,2.81,8.31.59a21.25,21.25,0,0,0,5.37-5.62V147.18s1.64,1.86,4.43,0a4.77,4.77,0,0,0,.93-7.14,3.31,3.31,0,0,0-5.36,1.49s-4,.15-9.4-2.8A15.08,15.08,0,0,1,397.77,127.53Z",
    style: {
      fill: "#ffc1a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,141a1.06,1.06,0,0,0,1,1.13,1.07,1.07,0,0,0,1.09-1,1.06,1.06,0,0,0-1-1.13A1.08,1.08,0,0,0,404,141Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.82,148l-2.42.78a1.24,1.24,0,0,0,1.57.86A1.33,1.33,0,0,0,402.82,148Z",
    style: {
      fill: "#f59f7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.49,137.78l2.1-1.46a1.23,1.23,0,0,0-1.75-.36A1.34,1.34,0,0,0,395.49,137.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,140.22a1,1,0,1,0,2.08.1,1.06,1.06,0,0,0-1-1.13A1.08,1.08,0,0,0,396,140.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.06 139.63 400.89 145.9 397.59 144.87 401.06 139.63",
    style: {
      fill: "#f59f7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.55,153.78c2.66-.35,8.14-1.92,9-4.09a5.6,5.6,0,0,1-1.92,2.77c-1.64,1.4-7.07,3-7.07,3Z",
    style: {
      fill: "#f59f7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,190.1c25.67-9.69,34.05-14.22,33.7-24.07-.13-3.46-1.86-5.07-4.27-5.71-3.32.14-5.81,4.39-10,9.47,0,0-15.13,7.74-20.68,10.62-6.55.21-20.4-1.91-25.61-3.25-.92-.24-1.49-1.64-2-2.43-1.43-2.12-2.9-2.48-4.67-4.06a11,11,0,0,1-1.36-1.49l-.39,4.28s-1.56,0-5-2.61c-3.84-2.9-6.11-3-6,3.16.1,3.85,2.57,6.84,11.13,9.45,2.47.75,6.42,1.65,9.61,2.39,4.78,1.11,6.38,1.35,11.05,2.46C382.53,189.49,389.75,191,392,190.1Z",
    style: {
      fill: "#ffc1a7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.57,140.75a4.05,4.05,0,0,0-1.73-2.29c-2.24-1.43-3.13-2.88-4.81-4.67-1.31-1.4-2.44-1.75-2.26-2.19a2.19,2.19,0,0,1,2.81-1,15.74,15.74,0,0,1,3.17,1.76,20.43,20.43,0,0,0-3.21-5.64c-3.12-3.9-3.24-6.27,3.13-6.27,4,0,7.26,1.51,10.18,10.33a87.36,87.36,0,0,1,2,10.18c1.31,7.61,2.6,17.42,2.21,22.74-.2,2.7-1.14,4.29-2.44,7.23s-15.51,29.3-19.19,34.21c-9.59-4.64-2.53-15.84-2.53-15.84s10.93-22.23,12.72-25a6.26,6.26,0,0,0,.85-2.29C277.75,160.61,277.2,146.29,276.57,140.75Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.94,190.76a11.84,11.84,0,0,0,6.46-3.43c3.83-3.5,8.19-11.29,8.19-11.29,3.47-.82,10.68,1.89,11,8.38L266.7,209.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.72,92.6,302,87.83l0,0c-.51-.29-4.85-2.82-9.09-5.26l-8.44-4.88a1,1,0,0,0-.59-.17l-7.46-.43a1.21,1.21,0,0,1-1.26-1.21,41.23,41.23,0,0,0,0-7.2,3.57,3.57,0,0,1,.82-2.2l11.94-1c.5-.62,10.28-10,10.28-10l-.06,0L280.55,45.25a.65.65,0,0,0-.34-.07L266.09,37a1.41,1.41,0,0,0-.86-.17l-8.7.87a2.42,2.42,0,0,0-1.9,1.32l-4.72,12.66a4.19,4.19,0,0,1-1.9,1.84c-.92.43-1.85.92-2.78,1.45l-9.13-5.28c-.36-.24-.94-.09-1.41.41l-9.56,10.09a2.55,2.55,0,0,0-.74,2.1l2.66,9a3,3,0,0,1-.49,2.17,71.91,71.91,0,0,0-4.39,7.63,3.44,3.44,0,0,1-2.07,1.54l-8.18,2a2.68,2.68,0,0,0-1.85,1.55L206,100a.89.89,0,0,0,.31,1c.18.15,9.26,5.38,9.26,5.38,0,1.26,0,2.5.16,3.71a3.53,3.53,0,0,1-.81,2.2l-8.34,10.09a2.28,2.28,0,0,0-.5,2.08l4,8.75a.72.72,0,0,0,.25.29l17.57,10.16s0,0,0,0h0a.18.18,0,0,0,.06-.08l.25.16h0l14.13,8.17h0c.24-.65,7.41-30.36,7.72-29.89l4.46,6.81a.54.54,0,0,0,.14.16l8.49,4.93,9.17,5.31h0l-6.63-20.7C271.52,120.58,284.87,95.4,280.72,92.6Zm-51.48,13.83,32.31-34.1a17,17,0,0,1,1.33,7.09,19,19,0,0,1,2.2-1.12c.07.75.1,1.55.1,2.38,0,11.16-7.82,24.71-17.48,30.29-.71.4-1.41.76-2.07,1.07a18.93,18.93,0,0,1-.14-2.53C238.6,113.54,232.05,112.62,229.24,106.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.72,92.6,302,87.83l0,0c-.51-.29-4.85-2.82-9.09-5.26l-8.44-4.88a1,1,0,0,0-.59-.17l-7.46-.43a1.21,1.21,0,0,1-1.26-1.21,41.23,41.23,0,0,0,0-7.2,3.57,3.57,0,0,1,.82-2.2l11.94-1c.5-.62,10.28-10,10.28-10l-.06,0L280.55,45.25a.65.65,0,0,0-.34-.07L266.09,37a1.41,1.41,0,0,0-.86-.17l-8.7.87a2.42,2.42,0,0,0-1.9,1.32l-4.72,12.66a4.19,4.19,0,0,1-1.9,1.84c-.92.43-1.85.92-2.78,1.45l-9.13-5.28c-.36-.24-.94-.09-1.41.41l-9.56,10.09a2.55,2.55,0,0,0-.74,2.1l2.66,9a3,3,0,0,1-.49,2.17,71.91,71.91,0,0,0-4.39,7.63,3.44,3.44,0,0,1-2.07,1.54l-8.18,2a2.68,2.68,0,0,0-1.85,1.55L206,100a.89.89,0,0,0,.31,1c.18.15,9.26,5.38,9.26,5.38,0,1.26,0,2.5.16,3.71a3.53,3.53,0,0,1-.81,2.2l-8.34,10.09a2.28,2.28,0,0,0-.5,2.08l4,8.75a.72.72,0,0,0,.25.29l17.57,10.16s0,0,0,0h0a.18.18,0,0,0,.06-.08l.25.16h0l14.13,8.17h0c.24-.65,7.41-30.36,7.72-29.89l4.46,6.81a.54.54,0,0,0,.14.16l8.49,4.93,9.17,5.31h0l-6.63-20.7C271.52,120.58,284.87,95.4,280.72,92.6Zm-51.48,13.83,32.31-34.1a17,17,0,0,1,1.33,7.09,19,19,0,0,1,2.2-1.12c.07.75.1,1.55.1,2.38,0,11.16-7.82,24.71-17.48,30.29-.71.4-1.41.76-2.07,1.07a18.93,18.93,0,0,1-.14-2.53C238.6,113.54,232.05,112.62,229.24,106.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M285.86,87.79l-5.1-10.47-4.4-.25a1.21,1.21,0,0,1-1.26-1.21c.11-1.31.16-2.6.16-3.85L263,73.66l-.7.82a18.63,18.63,0,0,1,.6,4.94,19,19,0,0,1,2.2-1.12c.07.75.1,1.55.1,2.38,0,11.16-7.82,24.71-17.48,30.29-.71.4-1.41.76-2.07,1.07a18.93,18.93,0,0,1-.14-2.53,17.43,17.43,0,0,1-6.27,2.32l-.16.46,9,16.57.08,0a54.23,54.23,0,0,1,1.94-6.83l4.46,6.81a.54.54,0,0,0,.14.16l8.49,4.93,9.17,5.31h0l-6.63-20.7c5.86,2,19.21-23.16,15.06-26l4.11-.92Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.06,127.91s-7,8.29-12.33,15.14l1.08.62s0,0,0,0h0a.18.18,0,0,0,.06-.08l.25.16h0l14.13,8.17h0c.14-.38,2.7-10.91,4.84-19.37Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.4,111.39a3.88,3.88,0,0,1-.53.91l-8.34,10.09a2.28,2.28,0,0,0-.5,2.08l4,8.75a.72.72,0,0,0,.25.29l5.12,3,9,3.13L236,123.3Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.24,106.43l1.52-1.61c-7.26-1.73-17.26-4.08-17.26-4.08l-.92,4,2.94,1.7c0,1.26,0,2.5.16,3.71a2.77,2.77,0,0,1-.28,1.29L236,123.3s5.88-10.36,5.59-10.85c-.06-.11-.3-.49-.63-1C235.88,112.86,231.42,111.25,229.24,106.43Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.28,93.72,221.2,82.13a3.64,3.64,0,0,1-1.1.51l-8.18,2a2.68,2.68,0,0,0-1.85,1.55l-3,10.1,19.18,8.08,11.37-6.75Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.51,83.75l5.39-10.09-3.64-13.13-20.35-3.27-2.78,2.93a2.55,2.55,0,0,0-.74,2.1l2.66,9a2.31,2.31,0,0,1-.06,1.18Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,52.87l22,12.71L277,43.34c-4.91-2.83-10.78-6.24-11-6.34a1.41,1.41,0,0,0-.86-.17l-8.7.87a2.42,2.42,0,0,0-1.9,1.32l-4.72,12.66A3.41,3.41,0,0,1,249,52.87Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.83,143.69l-.85-8.14-21-12.11a1.63,1.63,0,0,0,0,1l4,8.75a.6.6,0,0,0,.25.29h0l0,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.48,97.18,210.36,85.62a1.63,1.63,0,0,0-.29.53L206,100a.9.9,0,0,0,.31,1l.15.09,9.07,5.25,0,0h0l8.43,4.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.46,61.39l17.59,10.1,11.61-11.64L236.1,49.69h0a1.18,1.18,0,0,0-1.41.42l-9.56,10.09A3,3,0,0,0,224.46,61.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09,37a1.35,1.35,0,0,0-.86-.16l-8.7.86a2.5,2.5,0,0,0-1.45.69L278,51.6l5.85-3.38-.17-1.06S266.38,37.18,266.09,37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.83,143.69l-.85-8.14-21-12.11a1.63,1.63,0,0,0,0,1l4,8.75a.6.6,0,0,0,.25.29h0l0,0Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.48,97.18,210.36,85.62a1.63,1.63,0,0,0-.29.53L206,100a.9.9,0,0,0,.31,1l.15.09,9.07,5.25,0,0h0l8.43,4.88Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.46,61.39l17.59,10.1,11.61-11.64L236.1,49.69h0a1.18,1.18,0,0,0-1.41.42l-9.56,10.09A3,3,0,0,0,224.46,61.39Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09,37a1.35,1.35,0,0,0-.86-.16l-8.7.86a2.5,2.5,0,0,0-1.45.69L278,51.6l5.85-3.38-.17-1.06S266.38,37.18,266.09,37Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,87.83l0,0a1.23,1.23,0,0,0-.54-.14l-7.46-.42A1.21,1.21,0,0,1,292.68,86c.1-1.18.16-2.36.17-3.49a34.61,34.61,0,0,0-.16-3.71,3.66,3.66,0,0,1,.81-2.21l8.34-10.09a2.29,2.29,0,0,0,.51-2.07l-4-8.76a.64.64,0,0,0-.24-.27l-.06,0a1.22,1.22,0,0,0-1.27.4l-8.9,8.13a1.58,1.58,0,0,1-1.95.32,13.94,13.94,0,0,0-3.8-2.21,1.43,1.43,0,0,1-.9-1.56L284,48a.78.78,0,0,0-.38-.88,1.44,1.44,0,0,0-.83-.15l-8.7.87a2.38,2.38,0,0,0-1.9,1.33l-4.72,12.65a4,4,0,0,1-1.9,1.83,39,39,0,0,0-5.39,3.13c-.73.49-1.55.53-1.87,0l-4.45-6.8c-.32-.48-1-.38-1.61.22l-9.56,10.1a2.54,2.54,0,0,0-.74,2.09l2.66,9a3.06,3.06,0,0,1-.48,2.17,72,72,0,0,0-4.4,7.63,3.53,3.53,0,0,1-2.07,1.55l-8.18,2a2.7,2.7,0,0,0-1.85,1.53l-4.12,13.86a1,1,0,0,0,1,1.25l7.47.42a1.23,1.23,0,0,1,1.26,1.22,38.41,38.41,0,0,0,0,7.19,3.5,3.5,0,0,1-.81,2.21l-8.33,10.1a2.26,2.26,0,0,0-.51,2.07l4,8.75a.53.53,0,0,0,.24.27s0,0,0,0h0a.68.68,0,0,0,.31.08h0a1.56,1.56,0,0,0,1-.46l8.89-8.13a1.57,1.57,0,0,1,1.94-.33,14,14,0,0,0,3.81,2.21,1.4,1.4,0,0,1,.89,1.56l-2.74,12.46a.78.78,0,0,0,.36.86h0a1.36,1.36,0,0,0,.81.15l8.71-.86a2.43,2.43,0,0,0,1.9-1.33l4.73-12.65a4,4,0,0,1,1.9-1.84c.91-.43,1.84-.93,2.76-1.46s1.75-1.07,2.63-1.66c.72-.5,1.55-.53,1.86-.05l4.46,6.81a.8.8,0,0,0,.21.2c.36.22.92.06,1.39-.43l9.56-10.09a2.52,2.52,0,0,0,.73-2.1l-2.66-9a3.06,3.06,0,0,1,.5-2.17,73.82,73.82,0,0,0,4.39-7.64,3.45,3.45,0,0,1,2.08-1.54l8.17-2a2.69,2.69,0,0,0,1.85-1.54l4.12-13.85A.93.93,0,0,0,302,87.83Zm-43.63,33.85-.49.13-.34.07c-.26.05-.52.1-.78.13s-.6.07-.89.09l-.56,0H255a8.73,8.73,0,0,1-8.2-5.51,15,15,0,0,1-1.2-4.57,18.93,18.93,0,0,1-.14-2.53c0-7.89,4.11-17.67,10.8-24.74a30.32,30.32,0,0,1,6.59-5.35,19,19,0,0,1,2.2-1.12,13.89,13.89,0,0,1,6.17-1.3h.07l.31,0,.32,0a1.24,1.24,0,0,1,.33,0,8.74,8.74,0,0,1,6.85,5.41c3.69,8.17-.54,22.42-9.46,31.83C265.93,118.28,262,120.76,258.35,121.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.55,
    y1: 45.25,
    x2: 298.14,
    y2: 55.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.36,
    y: 343.36,
    width: 7.6,
    height: 13,
    transform: "translate(460.21 706.31) rotate(-178.36)",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.87,352.72l0-1.08c.71.33,2.22,6.82,5.15,9.66,2.33,2.25,5.53,4.86,6.29,7.32s-4.66,3.8-6.89,3.34c-2.59-.53-7-2.49-8.12-4.22s-1.54-4.25-2.43-5.52-3-2.72-3.41-4.17a9.22,9.22,0,0,1,.54-4c.39-1.33.82-2.8,1.27-2.66,0,.16,0,.83,0,.83a6.06,6.06,0,0,0,3.76,1.39C236.16,353.71,238.86,353.57,238.87,352.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.46 347.13 260.04 347.61 260.81 333.87 252.85 333.38 252.46 347.13",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.19,345.27c.39,0,.7.59,1.54,1.56a16.84,16.84,0,0,0,4.37,3.34c2.81,1.5,8.27,3.85,10.74,5.05,1.54.75,1.42,2.63-.23,3.66s-5.57,1.69-10.22.51c-2.54-.65-5.79-3.1-7.9-3s-6-.08-7.55-1.19-.84-3.38-.34-5.33c.54-2.13,1.23-5.45,1.94-5.28l0,.73c.88,1.41,5.57,2.11,7.61,1.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.09,246.12c-.21,7.25-.13,49.45-.13,49.45-.24,2.08-2.35,5.73-2.72,13.24-.54,10.89,2.8,40.93,2.8,40.93a10,10,0,0,0,8.44.41s4.61-40.46,6.28-51.2c1.45-9.38,4.2-34.9,4.2-34.9l2.7,30.84a43.21,43.21,0,0,0-1.29,12c.21,5,.73,35.94.73,35.94a10.41,10.41,0,0,0,8.75.92s6.61-43.89,6.83-48.46c.25-5.22-.31-58.55-.31-58.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.09,246.12c-.21,7.25-.13,49.45-.13,49.45-.24,2.08-2.35,5.73-2.72,13.24-.54,10.89,2.8,40.93,2.8,40.93a10,10,0,0,0,8.44.41s4.61-40.46,6.28-51.2c1.45-9.38,4.2-34.9,4.2-34.9l2.7,30.84a43.21,43.21,0,0,0-1.29,12c.21,5,.73,35.94.73,35.94a10.41,10.41,0,0,0,8.75.92s6.61-43.89,6.83-48.46c.25-5.22-.31-58.55-.31-58.55Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,264.05a28,28,0,0,0,10.75-5.76s-2.15,3.76-8.32,7.15l0,26.85Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4,178.6c-.72-.46-4.38.9-6.81,3.67s-3,6.94-2.45,7.88,9.5-2,9.5-2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,195a7,7,0,0,0-3.66,3.81c-.59,1.52-2.39,4-2.39,6.87l1.28,14.58-.56,26.08a35.17,35.17,0,0,0,37.05-2.88s-1-33.63-1-39.55c0-.27,0-.54,0-.81a13.32,13.32,0,0,0-10.5-12.24c-2.06-.47-13.32,1.87-13.32,1.87L236,195Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.16,176.19c1.72,5.15,16.69,30.49,20.37,35.4,9.59-4.64,2.53-15.84,2.53-15.84s-12.18-23.3-13.51-26.29c-.83-1.84-.81-13.4-.72-18.9a16.21,16.21,0,0,1,.51-4.4c.44-1.65,1.08-2.72,1.18-4.46a13.16,13.16,0,0,0-1-4.19c-.77-2-1.59-4.55-1.11-6.74a4.3,4.3,0,0,0,.19-1.06,3,3,0,0,0-1-1.82,33.43,33.43,0,0,0-2.57-2.48,6.79,6.79,0,0,0-1.77-1.19,2.49,2.49,0,0,0-2.07,0,3.12,3.12,0,0,0-1.27,1.48,12.25,12.25,0,0,0-1.12,5.7,27,27,0,0,0,.4,3.81c.19,1.17-.09,9.08-.12,11.93-.08,7.72-.74,15.93-.34,21.25A28.25,28.25,0,0,0,212.16,176.19Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.73,194.52,227.4,178.6s0,9.73-9.26,11.55L230.54,212c1.27,2.75,5.39.73,7-5C239.68,199,237.73,194.52,237.73,194.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.54,
    cy: 166.09,
    r: 10.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.49,173.51s1.69,7.94,2.37,9.25a3.64,3.64,0,0,0,2.08,1.68l-.12-5.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.62,162.12a3.94,3.94,0,0,0-3.25,1.14c-1.39,1.43-.61,5.88,1.12,10.25l3.19.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.63,173.88c-.63.38-1.55-.85-2.33-1.68s-3.36-1.95-4.65.76,1.14,6.39,3.16,7c3.49,1.09,4-1.14,4-1.14l.26,14.11h0c4.34,5.56,16.38,5.14,11.36-.67v-5a22,22,0,0,0,4.71.24c2.56-.4,4.18-2.42,5-5.2,1.25-4.46,1.72-8.06.66-16.84-1.16-9.62-12.35-9.72-18.39-5.91S241.63,173.88,241.63,173.88Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.64,175c-.33,0-1.55-2-2.34-2.75-1.11-1,.32-10.08.32-10.08a4.3,4.3,0,0,1,1.06-4.59c1.51-1.66,3.15-2.71,7.5-2.94a85.25,85.25,0,0,1,8.92.42c4.3.29,5.88-.77,8.35-1.46,1.89-.53,2.11,6.29-2.67,8.54,0,0-1.55,1-5.64,1.5a60.21,60.21,0,0,1-11.32-.21c-1.19-.16-1.44,1-2.08,4.12C243.18,170.26,242.71,174.93,241.64,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.62,162.83l-3.86-2.07a2.13,2.13,0,0,1,2.92-1A2.3,2.3,0,0,1,239.62,162.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43,187.27s-5.72-1.16-7.73-2.22a6.64,6.64,0,0,1-2.77-2.74,9.06,9.06,0,0,0,1.58,3.23c1.46,1.87,8.92,3.25,8.92,3.25Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.15,172.44a1.15,1.15,0,1,1-1.14-1.19A1.16,1.16,0,0,1,253.15,172.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.94,168.11l-2.46,1.35a1.48,1.48,0,0,1,.57-2A1.37,1.37,0,0,1,251.94,168.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.92,180.37l2.62,1a1.37,1.37,0,0,1-1.78.86A1.46,1.46,0,0,1,252.92,180.37Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.06,169.06l-2.24-1.72a1.36,1.36,0,0,1,1.95-.3A1.49,1.49,0,0,1,263.06,169.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.37,172.12a1.17,1.17,0,0,1-1.15,1.19,1.19,1.19,0,0,1-1.15-1.2,1.15,1.15,0,1,1,2.3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.52 171.03 256.9 177.93 260.5 176.7 256.52 171.03",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.17,141c-.83-2.74-2-4.27-3.12-6.58-1.66-3.59-.24-6,.11-5.24.75,1.66,3.35,5.31,4.12,5.31s1,4,1,4Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.94,228.42c.25-7.39,3.68-11.16,7.16-15.74,6.4-8.39,12.68-16.85,12.68-16.85s16.88-35.09,18.34-38.32c1.73-3.84,9.66.45,8.15,3,0,0-1.7,3.55-3,6.92-4.92,12.4-9.42,24.48-14.55,36.58l-20.31,25.7Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.66,106h0a1.23,1.23,0,0,0-.83.07l-9.21,4.15a1.08,1.08,0,0,1-1.53-.7c-.36-1.16-6.67-2.5-7.19-3.5l3.55-8.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,97.22v0a.86.86,0,0,0-.8,0l-6.8-15.73a1.38,1.38,0,0,0-.55-1.8l-6.66-3.85a1.38,1.38,0,0,0-1.83.43l-7.65,11.5a2.54,2.54,0,0,1-2,1,20.26,20.26,0,0,0-2.67.12V80.45l-5.11-3h0a.86.86,0,0,0-.84.08l-10.35,6A2.8,2.8,0,0,0,137,85.49l-1,11.51a3.83,3.83,0,0,1-1.07,2.15,61.72,61.72,0,0,0-5.75,6.09,2,2,0,0,1-2,.57l-6.64-2.32a1.63,1.63,0,0,0-1.86.69l-7.61,13.18a1.61,1.61,0,0,0,.33,2l5.33,4.6a2,2,0,0,1,.52,2,62.11,62.11,0,0,0-2.4,8,3.83,3.83,0,0,1-1.32,2L104,142.65a2.77,2.77,0,0,0-1.06,2v11.95a.83.83,0,0,0,.37.77h0l12,6.92-4.37,8.81a1.38,1.38,0,0,0,.54,1.8l16.29,9.44a1.4,1.4,0,0,0,1.83-.43l7.41-7.57a.87.87,0,0,0,.39.71l15.18,8.75.4-11.88s-3.21-4.14-3.14-4.85l16.53-18a1.62,1.62,0,0,0,1.87-.69l7.61-13.17a1.65,1.65,0,0,0-.34-2l7.33-23.32a2.79,2.79,0,0,0,1-2Zm-40.09,50.26c-4.44,2.56-8.11,3.11-10.78,1.87-3.13-1.45,22.27-45,24.94-42.62,2.15,1.92,3.32,5.49,3.32,10.47C160.84,128.35,153,141.91,143.36,147.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,87.3l-2.06,4.16-6.61,7.63-7.79-4.5L158.6,88.27a1.64,1.64,0,0,0,.55-.53l7.66-11.5a1.39,1.39,0,0,1,1.81-.44l6.68,3.86,10.14,5.84A1.39,1.39,0,0,1,186,87.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.1,135.25a2.94,2.94,0,0,1-.7.74L104,142.65a2.4,2.4,0,0,0-.65.75l15.89,9.2,12.55-7.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.79,103.42a1.64,1.64,0,0,0-1.24.76l-7.61,13.18a1.5,1.5,0,0,0-.17,1L127.43,128l10.41-14.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.58,86.29v3.78l-9.21,5.32L137.11,84.85a2.76,2.76,0,0,1,1.07-1.29l10.35-6a1.09,1.09,0,0,1,.52-.15.62.62,0,0,1,.31.07l5,2.87.13.08,6.88,4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,118.69v-12a.77.77,0,0,0-1.18-.76l-9.21,4.16a1.1,1.1,0,0,1-1.54-.71,20.12,20.12,0,0,0-2.05-4.57,2.54,2.54,0,0,1-.14-2.23l6.14-12.38a1.39,1.39,0,0,0-.54-1.8l-6.67-3.85A1.38,1.38,0,0,0,182,85l-7.65,11.5a2.53,2.53,0,0,1-2,1,20.86,20.86,0,0,0-5,.5,1.09,1.09,0,0,1-1.38-1l-1-10a.77.77,0,0,0-1.25-.64l-10.34,6a2.83,2.83,0,0,0-1.24,1.94l-1,11.51a3.91,3.91,0,0,1-1.08,2.15A62.93,62.93,0,0,0,144.3,114a2,2,0,0,1-2,.57l-6.65-2.32a1.63,1.63,0,0,0-1.86.69l-7.61,13.18a1.61,1.61,0,0,0,.33,2l5.33,4.6a2,2,0,0,1,.52,2.05,62,62,0,0,0-2.39,8,3.84,3.84,0,0,1-1.33,2l-9.45,6.66a2.8,2.8,0,0,0-1.06,2v11.95a.77.77,0,0,0,1.18.76l9.21-4.15a1.1,1.1,0,0,1,1.54.71,20.32,20.32,0,0,0,2.05,4.57,2.54,2.54,0,0,1,.14,2.23l-6.14,12.38a1.39,1.39,0,0,0,.54,1.8l6.67,3.85a1.4,1.4,0,0,0,1.83-.43l7.65-11.51a2.56,2.56,0,0,1,2-1,20.86,20.86,0,0,0,5-.51,1.1,1.1,0,0,1,1.38,1l1,10.05a.77.77,0,0,0,1.25.64l10.34-6a2.79,2.79,0,0,0,1.24-1.93l1-11.51a3.83,3.83,0,0,1,1.07-2.15,61.72,61.72,0,0,0,5.75-6.09,2,2,0,0,1,2-.57l6.65,2.32a1.62,1.62,0,0,0,1.86-.7L191,146a1.63,1.63,0,0,0-.33-2l-5.33-4.59a2,2,0,0,1-.52-2,62,62,0,0,0,2.39-8,3.83,3.83,0,0,1,1.33-2l9.45-6.65A2.8,2.8,0,0,0,199,118.69Zm-40.47,37.57c-9.66,5.58-17.48,1.06-17.48-10.09s7.82-24.71,17.48-30.28,17.48-1.06,17.48,10.09S168.23,150.69,158.57,156.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Girl--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.32,381.5l-.69-9.93-8.36-.59.38,8.5c-.19,2-1.52,2.79-1.76,3.94s6.85,11.88,10.46,14.05,8.7-1.6,9.1-2.86c.55-2-5.32-2-5.52-2.12a2.52,2.52,0,0,1-.38-.21A100.86,100.86,0,0,1,124.32,381.5Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.1,381.2c1.17.79,2.23,3,4,5.93s4,7.11,7,7.82c2.75.66,6.27-1.41,4.21-1.89-.72-.17-2.25-.34-2.45-.45a1.2,1.2,0,0,1-.33-.32s1.53.26,3.92.42A3.88,3.88,0,0,1,135,395c.45.91-.16,3.45-6,4.44-4.23.71-7.19.68-9.08-2.16-2.29-3.45-6.09-7-7.67-8.88C110.3,386,112.6,382.12,115.1,381.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.14,373.56l4.8-10.71-7.23-3.76-4.08,8.43c-1.27,1.71-3.13,1.15-4,2.06s-.31,14.49,1.76,18.41c1.2,2.28,3.94,3,6.25,3.08,1.66,0,1-2.52-.18-4a1.58,1.58,0,0,1-.42-1C66.08,383.3,69.14,373.56,69.14,373.56Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,368.23a47.34,47.34,0,0,1,2.15,8.2c.79,3.94,1.75,9.23,2.43,10.5s.55-.12.53-.89c0,.44.9,1.38,1.14,1.7a32.12,32.12,0,0,1,2.59,3.32c.41.72,1.12,2,.7,2.74s-1.49.86-2.19.92-3.8.65-8.53-2.24A9,9,0,0,1,58,390.65c-1.79-2.62-1.45-5-1.75-8-.41-4-1.71-5-2.39-7.7a9.55,9.55,0,0,1-.11-3.28C54.47,368.93,58.2,367.69,61,368.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.22,382.67c.3,2.95,0,5.36,1.75,8a9,9,0,0,0,1.81,1.83c4.73,2.89,7.76,2.3,8.53,2.24a4.84,4.84,0,0,0,.9-.17c-5.52-.19-7.08-5.18-7.75-8.22s-2-11.69-3.5-13.8-4.24-.84-4.24-.84a9.55,9.55,0,0,0,.11,3.28C54.51,377.68,55.81,378.69,56.22,382.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.17,270s-17,43.95-18.42,48.64A38.12,38.12,0,0,1,93.44,330c-1.82,2.75-22.33,39.14-22.33,39.14-5.6-1.69-6.91-5.3-6.91-5.3s6.52-29.27,8.81-33.78a30.67,30.67,0,0,1,8.23-9.44l5.6-35.5c.6-5.87-2.55-16.91,6.93-25.3l-.15,2.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.87,267c-3.51,6.2-6.87,11.67-7.28,18.43-.85,14.28,7,29.4,8.72,39.83,0,0-2.69,7.12-2.38,12.66.25,4.34,7.2,38,7.2,38s5,2.38,9-.07c0,0,2.52-49,2.24-67.82s-2.78-45.28-2.78-45.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,262.74l-29.18-2.9c-1.71,3.55-6.17,12.26-4.57,17.65,1.94,6.53,6,10.84,17.28,13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.15,304l-4-16.3s-7.17-1.93-10.6-5.7a18,18,0,0,0,7.8,7.93c.54.55,5.5,17.61,5.5,17.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.88 217.77 115.67 228.35 105.25 229.55 106.75 215.52 116.88 217.77",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.21,231.34c.18.9.63,2.9,1.47,5.91,1.53,5.54,4.16,13.07,5.15,15.71.06.11.09.21.13.29L93.84,260s2.77,3.41,11,5.8S123,263.29,123,263.29l3.39-19.41c1.13-2.89,3.19-6.79,5.45-8.15,1.13-.67,16.16-11.47,20-13.78,3.09-1.87,4.3-3.21,4.82-4.68s5.87-23.57,6.73-26,1.66-3.14,3.57-5.17,2.57-2.5,3.15-4.33-.15-2.27-.44-3.18c-.41-1.25.05-2.13-.23-3.08-.34-1.18-1.07-1.49-1.25-2-.28-.84,0-1.3-.49-2.82a4,4,0,0,0-1.84-2.19l-.31,3.49c-1,4.28-5.52,5.81-6.12,5.51s-1.48-2.75-2.79-3.82-3.12-.94-2.45.36c.37.75,1.24,3.56,1.68,4.8s1.77,3.85,1.48,5.84c-.38,2.66-9.77,26.76-9.77,26.76a176,176,0,0,1-16.78,8.93,71.84,71.84,0,0,1-10.55,4.31c-.73-.13-3.74-.17-5.15-.42-.39-.08-.81-.15-1.24-.22-5.51-1-13.84-2.56-16.1-3l-.58-.11a6.07,6.07,0,0,0-1.59.05,5.53,5.53,0,0,0-3.41,2.9A11,11,0,0,0,91.21,231.34Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.18,224.69c-.73-.13-3.74-.17-5.15-.42l-1.24-.22c-4.81-.85-10.4-1.87-14.75-2.72a14,14,0,0,0-7.79,13.73c.39,5.66,4.31,14.47,5.25,17h0a49.55,49.55,0,0,0-8.66,15.82s3,7.54,17.73,9c15.05,1.49,19.22-5.45,19.22-5.45l-.74-13.87c.66-3.52,2-9.51,2.32-13.66C118.1,240.54,120.18,224.69,120.18,224.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.37,249.19s3.06,4.58,10.2,6.26c-3.82-.19-7.13-.84-9.07-3.42Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.13,192.1c2.53,1.1,7.24.31,8.89,12.07,1.3,9.26-.37,12.43-1.56,13.73-.79.88-5.95,1.69-8.29,1.13-2.93-.7-9.36-3.36-12.59-7.95-3.81-5.39-5-12.84-1.26-16.05C106.62,190.52,114,191.17,116.13,192.1Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.85,203.72s2.77,3.64,2.47,4.07a6.1,6.1,0,0,1-1.87,1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.37,188.27c-3.59-3.19-11-4.52-17.46-.39-1.19.31-2.42.7-3.67,1.16a10.61,10.61,0,0,0-3.44,2.14,2.16,2.16,0,0,0-.12-1.32,2.28,2.28,0,0,0-3-1.2l1.16,2.74a2.07,2.07,0,0,0-.7-.34,2.27,2.27,0,0,0-2.8,1.57l3.39,1a16.91,16.91,0,0,0-2.69,8.84c-.07.7-.1,1.4-.1,2.11h0v15.23a10.86,10.86,0,0,0,8.62,10.63l15.31,3.25-.34-21.39a6.6,6.6,0,0,1-2.33-.2,4.41,4.41,0,0,1-2.19-1.3c-2-2.2-1.34-6.05.63-6.58a3,3,0,0,1,3.15.88l.65,1,.46,2.14.17.81a2.26,2.26,0,0,0,1.74-2.69,2.07,2.07,0,0,0-.2-.56l.26-.37C127.17,201.23,126.08,191.57,122.37,188.27Z",
    style: {
      fill: "#37474f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrerCardImg2);
export default __webpack_public_path__ + "static/media/CarrerCardImg2.bcd20dec56b3827488b9915625cc0263.svg";
export { ForwardRef as ReactComponent };